import classNames from 'classnames';
import { forwardRef } from 'react';
const svgComponentCss = "s1rxtl95";
const SvgComponent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'svg';
  return <Component ref={ref} {...restProps} className={classNames(svgComponentCss, props.className)} />;
});
const bodyCheckedCss = "b1nx1k15";
const bodyDisabledCss = "b1k9bh";
const bodyCss = "bcis4l9";
const Body = forwardRef((props, ref) => {
  const {
    checked,
    disabled,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, {
    [bodyCheckedCss]: checked,
    [bodyDisabledCss]: disabled
  }, props.className)} />;
});
export const CheckboxUI = ({
  checked,
  disabled
}) => <Body checked={checked} disabled={disabled}>
    {checked && <SvgComponent xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d={`M23.15,5.4l-2.8-2.8a.5.5,0,0,0-.7,0L7.85,14.4a.5.5,0,0,1-.7,0l
                  -2.8-2.8a.5.5,0,0,0-.7,0L.85,14.4a.5.5,0,0,0,0,.7l6.3,6.3a.5.5,0,
                  0,0,.7,0L23.15,6.1A.5.5,0,0,0,23.15,5.4Z`} fill="currentColor" />
      </SvgComponent>}
  </Body>;

require("./checkbox_ui.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./checkbox_ui.js");